export default {
  "finance.title": "المالية والتسويات",
  "finance.subtitle": "متابعة الإيرادات والمستحقات وطلبات التسوية",
  "finance.requestSettlement": "طلب تسوية",
  "finance.backToHome": "العودة إلى الرئيسية",
  "finance.demoNote": "هذه معاينة ببيانات تجريبية.",

  "finance.tab.revenue": "ملخص الإيرادات",
  "finance.tab.dues": "المبالغ المستحقة",
  "finance.tab.settlements": "سجل التسويات",

  "finance.period.today": "اليوم",
  "finance.period.week": "الأسبوع",
  "finance.period.month": "الشهر",
  "finance.period.label": "الفترة",

  "finance.card.direct": "إيرادات الطلبات المباشرة",
  "finance.card.directHint": "قيمة الطلبات المكتملة في الفترة المختارة.",
  "finance.card.deliveryFees": "رسوم التوصيل المحوّلة للمغسلة",
  "finance.card.deliveryFeesHint": "رسوم المهام المنفذة بواسطة مندوبي المغسلة التابعين.",
  "finance.card.total": "إجمالي الإيرادات",
  "finance.card.totalHint": "إيرادات الطلبات المباشرة مع رسوم التوصيل المحوّلة.",

  "finance.details.title": "تفاصيل العمولات والمستحق لكل طلب",
  "finance.details.col.order": "رقم الطلب",
  "finance.details.col.finalTotal": "القيمة النهائية للطلب",
  "finance.details.col.commissionRate": "نسبة العمولة",
  "finance.details.col.commissionAmount": "مبلغ العمولة",
  "finance.details.col.deliveryFee": "رسوم التوصيل المحوّلة",
  "finance.details.col.net": "صافي المستحق",
  "finance.details.viewOrder": "عرض الطلب",
  "finance.details.debtBadge": "مديونية عميل",
  "finance.details.note": "تُحتسب مستحقات المغسلة على القيمة النهائية للطلب، ولا تتأثر بالمديونية المسجلة على العميل.",
  "finance.details.empty": "لا توجد إيرادات مسجلة لهذه الفترة",
  "finance.details.emptyDesc": "لم تُسجَّل أي إيرادات ضمن الفترة المختارة.",
  "finance.details.error": "تعذّر تحميل ملخص الإيرادات",

  "finance.none": "لا توجد",

  "finance.outstanding.title": "المبالغ المستحقة",
  "finance.outstanding.balanceLabel": "الرصيد المستحق غير المسوّى",
  "finance.outstanding.note": "الرصيد المتراكم غير المسوّى مستقل عن اختيار اليوم أو الأسبوع أو الشهر.",
  "finance.outstanding.breakdown": "تفاصيل المكوّنات",
  "finance.outstanding.orderComponent": "مستحقات طلب",
  "finance.outstanding.packageComponent": "مستحقات الباقات",
  "finance.outstanding.packagePending": "لم تتوفر بيانات مالية معتمدة لاستحقاق الباقات بعد، وتُعرض مستحقات الطلبات الواضحة فقط.",
  "finance.outstanding.request": "طلب تسوية",
  "finance.outstanding.empty": "لا توجد مبالغ مستحقة غير مسوّاة",
  "finance.outstanding.emptyDesc": "لا يوجد رصيد قابل للتسوية حاليًا.",
  "finance.outstanding.error": "تعذّر تحميل المبالغ المستحقة",

  "finance.req.title": "طلب تسوية",
  "finance.req.amountLabel": "إجمالي المبلغ المستحق المعتمد",
  "finance.req.note": "سيُرسل طلب التسوية إلى الإدارة للمعالجة والتحويل إلى حساب المغسلة البنكي.",
  "finance.req.readonly": "المبلغ للعرض والمراجعة وفق بيانات النظام، ولا يمكن تعديله.",
  "finance.req.confirm": "تأكيد طلب التسوية",
  "finance.req.cancel": "إلغاء",
  "finance.req.loading": "جارٍ تحديث المبلغ المستحق…",
  "finance.req.noAmount": "لا يوجد مبلغ مستحق قابلاً للتسوية حاليًا.",
  "finance.req.error": "تعذّر إرسال طلب التسوية، حاول مرة أخرى.",
  "finance.req.toast": "تم إرسال طلب التسوية",

  "finance.set.title": "سجل التسويات",
  "finance.set.col.requestedAt": "تاريخ الطلب",
  "finance.set.col.processedAt": "تاريخ المعالجة",
  "finance.set.col.amount": "المبلغ",
  "finance.set.col.status": "الحالة",
  "finance.set.col.reason": "سبب الرفض",
  "finance.set.notProcessed": "لم تُعالج بعد",
  "finance.set.view": "تفاصيل التسوية",
  "finance.set.empty": "لم تُقدّم طلبات تسوية بعد",
  "finance.set.emptyDesc": "عند تقديم طلب تسوية سيظهر هنا بحالته.",
  "finance.set.error": "تعذّر تحميل سجل التسويات",
  "finance.set.detailsTitle": "تفاصيل التسوية",
  "finance.set.id": "رقم التسوية",
  "finance.set.amount": "المبلغ",

  "finance.setDetail.back": "العودة إلى سجل التسويات",
  "finance.setDetail.notFound": "لم يتم العثور على التسوية",
  "finance.setDetail.notFoundBack": "العودة إلى سجل التسويات",
  "finance.setDetail.error": "تعذّر تحميل تفاصيل التسوية",
  "finance.setDetail.infoTitle": "بيانات التسوية",
  "finance.setDetail.requestedAt": "تاريخ الطلب",
  "finance.setDetail.receiptTitle": "إثبات التحويل",
  "finance.setDetail.receiptAlt": "صورة إثبات التحويل البنكي",
  "finance.setDetail.receiptNote": "صورة إثبات التحويل البنكي كما وردت من الإدارة.",
  "finance.setDetail.receiptPending": "سيظهر إثبات التحويل هنا بعد إتمام المعالجة.",
  "finance.setDetail.receiptNone": "لم يُرفق إثبات تحويل لهذه التسوية.",
  "finance.setDetail.download": "تحميل صورة الإثبات",
  "finance.setDetail.downloading": "جارٍ التحميل…",
  "finance.setDetail.downloadStarted": "بدأ تحميل صورة الإثبات",
  "finance.setDetail.downloadStartedDesc": "احتفظ بالصورة للرجوع إليها في أي وقت.",
  "finance.setDetail.downloadError": "تعذّر تحميل صورة الإثبات",
  "finance.setDetail.receiptViewFull": "عرض بالحجم الكامل",
  "finance.setDetail.receiptZoomHint": "اضغط على الصورة لعرضها بالحجم الكامل قبل التحميل.",

  "finance.status.processing": "قيد المعالجة",
  "finance.status.transferred": "تم التحويل",
  "finance.status.rejected": "مرفوض"
};